<template>
  <div class="mdc-form-field mdc-switch-container">
    <label v-bind:for="id" class="mdc-switch-label typography--body-3 typography--color-secondary clickable">
      <slot name="label"></slot>
    </label>
    <div class="mdc-switch">
      <input type="checkbox"
             v-bind:id="id"
             class="mdc-switch__native-control" 
             v-bind:checked="state"
             v-on:change="onChange"/>
      <div class="mdc-switch__background">
        <div class="mdc-switch__knob"></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'toggle-switch',

    props: [
      'id',
      'model-value',
      'check-value',
    ],

    data() {
      return {
        isChecked: false,
      };
    },

    computed: {
      state() {
        return this.modelValue === this.checkValue;
      },
    },

    methods: {
      check() {
        return this.$emit('change', this.checkValue);
      },

      uncheck() {
        if (this.checkValue === true) {
          return this.$emit('change', false);
        }

        return this.$emit('change', null);
      },

      onChange() {
        if (this.state) {
          this.uncheck();
        } else {
          this.check();
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/ToggleSwitch.vue